import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { FormGroup } from "@angular/forms";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-quiz-base-choice',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ``,
    styles: [],
    standalone: false
})
export abstract class BaseChoiceComponent<TQuestion extends FlatModels.QuestionEntityModels.Question> {
  @Input({required: true}) set index(value: number) {
    this.#index = value;
    this.updateForm();
  }
  get index() {
    return this.#index;
  }
  @Input({required: true}) set question(value: TQuestion) {
    this.#question = structuredClone(value);
    this.updateForm();
  }
  get question() {
    return this.#question;
  }
  @Input({required: true}) set choice(value: FlatModels.ChoiceEntityModels.Choice) {
    this.#choice = structuredClone(value);
    this.updateForm();
  }
  get choice() {
    return this.#choice;
  }
  
  protected isSubmitted = signal(false);
  #index: number;
  #question: TQuestion;
  #choice: FlatModels.ChoiceEntityModels.Choice;
  form: FormGroup;
  readonly FlatModels = FlatModels;

  protected constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
                        public trainingSharedFacade: FlatFacades.TrainingSharedFacade,
                        public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
                        public historySharedFacade: FlatFacades.HistorySharedFacade) {
  }
  
  abstract updateForm(): void;
  abstract onSubmit(): void;
}
